import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "alert-body__content--delivery-date" }
const _hoisted_2 = { class: "alert-body__content--order-amount" }
const _hoisted_3 = { class: "alert-body__content--delivery-date" }
const _hoisted_4 = { class: "alert-body__content--order-amount" }

import { computed, ref, watch } from 'vue';
import { i18n } from '@/i18n';
import { onMounted } from 'vue';
import { AlertType } from '@/coreDomainsModule/entities/hasRecommendOrders';
import { simpleCopy } from '@/utils/deepCopy';
import AlertCell from '@/corePagesModule/components/table/AlertCell.vue';
import { AlertBasicDataObject } from '@/coreDomainsModule/alert';
import { OrderAlertKinds } from '@/orderTableModule/domains/entities/Alert';
import { assertNever } from '@/coreDomainsModule/assertNever';

// 2024/12/17 現状TableCellをWrapする形で実装していますが、良いタイミングでテーブルから直接呼ぶ形に変更してください。

/**
 * propsの定義
 * @param alertTypes - アラートの種類
 * @param deliveryDate - 納期
 * @param orderAmount - 発注数量
 */
type OrderAlertProps = {
  // テーブルに直接実装する際にはInventoryManageを参考にしてAlert共通のTypeを使用するように実装してください
  alertTypes: AlertType[];
  deliveryDate: string;
  orderAmount: string;
  isOpening: boolean;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'OrderAlert',
  props: {
    alertTypes: {},
    deliveryDate: {},
    orderAmount: {},
    isOpening: { type: Boolean }
  },
  emits: ["click", "onNext"],
  setup(__props: any, { emit: __emit }) {

/**
 * 発注ステータスバッジ
 */
const props = __props;

const emits = __emit;

const t = i18n.t;

// ランダムID生成
const imgId = ref<string>('');
onMounted(() => {
  imgId.value = Math.random().toString(32).substring(2);
});

const alertTypes = ref<AlertType[]>([]);
onMounted(() => {
  alertTypes.value = props.alertTypes;
});

/**
 * アラートかどうか
 * @param alertType - アラートの種類
 */
const isAlert = (alertType: AlertType) => {
  return alertType === 'OrderAmountWarning' || alertType === 'DeliveryDateWarning';
};

/**
 * アラートラベル
 * @param alertType - アラートの種類
 */
const alertLabel = (alertType: AlertType): string => {
  switch (alertType) {
    case 'OrderAmountWarning':
      return t('在庫がゼロ以下になる予想が出ています。発注数量や納期の見直し、または追加発注を検討してください。');
    case 'DeliveryDateWarning':
      return t('予定していた納期が過ぎています。倉庫へ入荷状況を確認してください。');
    case 'DeliveryDateInfo':
      return t('納期当日になりました。倉庫へ納入状況を確認してください。');
    case 'DeliveryDateConfirmedInfo':
      return t('発注を出力してから1週間経過しました。仕入先へ数量・納期の回答を確認してください。');
    default:
      assertNever(alertType);
      return '';
  }
};

watch(
  () => props.alertTypes,
  () => {
    alertTypes.value = simpleCopy(props.alertTypes);
  }
);

/**
 * チェックボタンを表示するかどうか
 * @param alertType - アラートの種類
 */
const showCheckButton = (alertType: AlertType) => {
  return alertType === 'OrderAmountWarning';
};

const makeAlertData = computed((): AlertBasicDataObject[] => {
  const res = [] as AlertBasicDataObject[];
  props.alertTypes.map((alertType) => {
    if (!(alertType in OrderAlertKinds)) {
      console.log('==========不正なアラートタイプ==========');
      return res;
    }
    res.push({
      kind: OrderAlertKinds[alertType],
      type: isAlert(alertType) ? 'error' : 'warning',
      title: isAlert(alertType) ? t('警告') : t('注意'),
      description: alertLabel(alertType),
      showConfirmButton: showCheckButton(alertType),
    });
  });
  return res;
});

const isOpening = ref(false);

watch(
  () => props.isOpening,
  () => {
    isOpening.value = props.isOpening;
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AlertCell, {
    "alert-data": makeAlertData.value,
    "prop-is-opening": isOpening.value,
    onOnNext: _cache[0] || (_cache[0] = ($event: any) => (emits('onNext', $event))),
    onClick: _cache[1] || (_cache[1] = ($event: any) => (emits('click', $event)))
  }, _createSlots({ _: 2 }, [
    (alertTypes.value.includes('OrderAmountWarning'))
      ? {
          name: `alertBody-orderAmountWarning`,
          fn: _withCtx(() => [
            _createElementVNode("span", _hoisted_1, _toDisplayString(_unref(t)('発注アラート：希望納期', { deliveryDate: _ctx.deliveryDate })), 1),
            _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(t)('発注アラート：発注数量', { orderAmount: _ctx.orderAmount })), 1)
          ]),
          key: "0"
        }
      : undefined,
    (alertTypes.value.includes('DeliveryDateWarning'))
      ? {
          name: `alertBody-deliveryDateWarning`,
          fn: _withCtx(() => [
            _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(t)('発注アラート：希望納期', { deliveryDate: _ctx.deliveryDate })), 1),
            _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(t)('発注アラート：発注数量', { orderAmount: _ctx.orderAmount })), 1)
          ]),
          key: "1"
        }
      : undefined
  ]), 1032, ["alert-data", "prop-is-opening"]))
}
}

})